export default {
  getVersions: state => state.versions,
  getAppVersion: state => state.appVersion,
  getFeatures: state => state.features
}
